///report/report_contractitems_by_customer
export const REPORT_CONTRACT_ITEMS_BY_CUSTOMER =
  "REPORT_CONTRACT_ITEMS_BY_CUSTOMER";
export const REPORT_CONTRACT_ITEMS_BY_CUSTOMER_SUCCESS =
  "REPORT_CONTRACT_ITEMS_BY_CUSTOMER_SUCCESS";
export const REPORT_CONTRACT_ITEMS_BY_CUSTOMER_FAIL =
  "REPORT_CONTRACT_ITEMS_BY_CUSTOMER_FAIL";
